import { Palette } from '@mui/material'

export const alertStyles = (palette: Palette, success: boolean) => ({
	width: '100%',
	backgroundColor: success ? palette.brand.main : palette.colors.red,
	color: 'white',
	borderRadius: '8px',
	fontWeight: 600,
})
